import * as Filter from '../components/filterGroup';

$(() => {
    if (document.getElementById('list-of-filings')) {
        Filter.Init();
    }
});
